import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Eye, Download, Share2 } from 'lucide-react';
import styles from './DesignDetail.module.css';

const DesignDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const designs = {
    1: {
      title: 'Character Design',
      category: 'Character Design',
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop',
      description: 'A vibrant character design showcasing unique personality and style.',
      tools: ['Adobe Illustrator', 'Procreate', 'Photoshop'],
      color: '#ec4899'
    },
    2: {
      title: 'Logo Creation',
      category: 'Logo Creation',
      image: 'https://images.unsplash.com/photo-1626785774573-4b799315345d?w=800&h=600&fit=crop',
      description: 'Modern logo design with clean typography and memorable branding.',
      tools: ['Adobe Illustrator', 'Figma'],
      color: '#a855f7'
    }
  };

  const design = designs[id] || designs[1];

  return (
    <div className={styles.container}>
      <button onClick={() => navigate(-1)} className={styles.backButton}>
        <ArrowLeft size={20} />
        Back to Portfolio
      </button>
      
      <div className={styles.content}>
        <div className={styles.imageSection}>
          <img src={design.image} alt={design.title} className={styles.mainImage} />
        </div>
        
        <div className={styles.detailSection}>
          <span className={styles.category}>{design.category}</span>
          <h1 className={styles.title}>{design.title}</h1>
          <p className={styles.description}>{design.description}</p>
          
          <div className={styles.tools}>
            <h3>Tools Used:</h3>
            <div className={styles.toolsList}>
              {design.tools.map((tool, index) => (
                <span key={index} className={styles.tool}>{tool}</span>
              ))}
            </div>
          </div>
          
          <div className={styles.actions}>
            <button className={styles.actionButton}>
              <Eye size={18} />
              View Full Size
            </button>
            <button className={styles.actionButton}>
              <Download size={18} />
              Download
            </button>
            <button className={styles.actionButton}>
              <Share2 size={18} />
              Share
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignDetail;